module.exports = __webpack_public_path__ + "static/media/klub.1882d89e.png";